import { render } from "./PaymentSeparator.vue?vue&type=template&id=88441cb4&scoped=true"
const script = {}

import "./PaymentSeparator.vue?vue&type=style&index=0&id=88441cb4&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88441cb4"]])

export default __exports__